import type { AxiosPromise } from "axios";

export type ApiResponse<T> = {
    data: T;
};

export type PaginationMeta = {
    currentPage: number;
    from: number;
    to: number;
    lastPage: number;
    perPage: number;
    total: number;
};

export type ApiResponseWithPaginationMeta<T> = ApiResponse<T> & {
    meta: PaginationMeta;
};

export type AxiosApiResponsePromise<T> = AxiosPromise<ApiResponse<T>>;
export type AxiosApiResponseWithPaginationMetaPromise<T> = AxiosPromise<ApiResponseWithPaginationMeta<T>>;

export enum ApiResponseErrorType {
    VALIDATION = "VALIDATION",
    AXIOS = "AXIOS",
    UNKNOWN = "UNKNOWN",
}

export type ValidationErrorDetail = {
    rule: string;
    message: string;
};

export type ValidationErrors = {
    [key: string]: ValidationErrorDetail[];
};

export type ErrorResponse = {
    errors: ValidationErrors;
};

export type ValidationErrorType = {
    type: ApiResponseErrorType.VALIDATION;
    code: number;
    messages: ValidationErrors;
};

export type AxiosErrorType = {
    type: ApiResponseErrorType.AXIOS;
    code: number;
    message: string;
    originalMessage: string | null;
};

export type UnknownErrorType = {
    type: ApiResponseErrorType.UNKNOWN;
    message: string;
};

export type ErrorResult = ValidationErrorType | AxiosErrorType | UnknownErrorType;
